// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__j0ORf","title":"InfoRow_title__6Qk89"};